import React, { useEffect } from "react";
import { Footer } from "@creditonebank/c1b-components";
import mobileIcon from "../../assets/MobileIcon.svg";
import "./footer.styles.css";

export const FooterComponent = ({currentYear}) => {

  const utilityLinks = [
    {
      icon: "pdf",
      label: "Privacy",
      link: "https://www.creditonebank.com/privacy",
    },
    {
      label: "Terms of Use",
      link: "https://www.creditonebank.com/terms-of-use",
    },
    {
      label: "Security & Fraud",
      link: "https://www.creditonebank.com/security",
    },
    {
      icon: "pdf",
      label: "Card Agreements",
      link: "https://www.creditonebank.com/content/dam/cob-corp-acquisition/pdfs/legal/cardholderagreements.pdf",
    },
  ];

  useEffect(() => {
    const nav = document.querySelector(".Footer__utility_nav__links");
    if(!nav) return;
    nav.setAttribute("aria-label", "Footer links");

    const liItems = Array.from(nav.querySelectorAll(":scope>li"));
    const ul = document.createElement("ul");
    liItems.forEach(li => ul.appendChild(li));
    nav.appendChild(ul);

    const svgLockClass = `.icon`;
    const svgIconLock = document.querySelector(svgLockClass);
    if(!svgIconLock) return;
    svgIconLock.setAttribute("aria-hidden", "true");
    svgIconLock.removeAttribute("role");

    const mobileAppLink = document.querySelector(".Footer__navigation__button");
    if(!mobileAppLink) return;
    mobileAppLink.removeAttribute("role");

    const mobileAppImg = mobileAppLink.querySelector(".Icon__utility");
    if(!mobileAppImg) return;
    mobileAppImg.setAttribute("alt", " ");
  }, [])

  return (
    <Footer
      utilityLinks={utilityLinks}
      copyright={`© ${currentYear} Credit One Bank, N.A. All Rights Reserved. Member FDIC.`}
      className="footer-style"
      utilityButton={{
        icon: {
          src: mobileIcon,
          alt: "Credit One Bank Mobile App Icon",
        },
        label: "Credit One Bank Mobile App",
        link: "https://www.creditonebank.com/mobile",
      }}
    />
  );
};
